import cx from 'classnames';

export function fieldClass(field, rest = {}) {
  return cx(
    'ui field',
    {
      error: field.touched && field.error,
    },
    rest
  );
}



// WEBPACK FOOTER //
// ./src/modules/common/semantic/utils.js